/** Legacy `<!-- zw-spacer -->` marker lines (pre-`.zwdoc`; read-only). */

import { formatSpacerHeight, type SpacerHeight } from "../spacerHeight";

export const SPACER_MARKER =
  /^<!--\s*zw-spacer:\s*([0-9]*\.?[0-9]+)\s*(em|px|rem)?\s*-->\s*$/i;

export function parseSpacerLine(text: string): SpacerHeight | null {
  const match = SPACER_MARKER.exec(text.trim());
  if (match === null) return null;
  const value = Number.parseFloat(match[1] ?? "");
  if (!Number.isFinite(value) || value <= 0) return null;
  const unit =
    (match[2]?.toLowerCase() as SpacerHeight["unit"] | undefined) ?? "em";
  return { value, unit };
}

export function isSpacerMarkerLine(text: string): boolean {
  return parseSpacerLine(text) !== null;
}

export function spacerHeightToCss(height: SpacerHeight): string {
  return formatSpacerHeight(height);
}
